import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {TAB_ENUM} from 'app/Components/Page/SelfCarePage/Constant';

const ROLES = {
  ContactBusiness: 256,
  ContactPrivate: 128,
  Subscriber: 64,
};

export const seperateLinks = {
  small: '|',
};

const brandNameHe = () => window.Config?.brand_Name_HE;
export const text = {
  selfCare: 'פעולות בשירות עצמי',
  get changeToBusiness() {
    return `מעבר ל${brandNameHe()} עסקים`;
  },
  get changeToPrivate() {
    return `מעבר ל${brandNameHe()} פרטי`;
  },
  disconnectUser: 'התנתק',
};

function isOnlyContactBusiness(role) {
  return (role & ROLES.ContactBusiness) === ROLES.ContactBusiness && (role & (ROLES.ContactPrivate | ROLES.Subscriber)) === 0;
}

const isUserInLobby = (lobbyUrl, currentPath, worldType) => {
  // Check if current path starts with the lobby URL
  const normalizedLobbyUrl = lobbyUrl.replace(/\/$/, '');
  const normalizedCurrentPath = currentPath.replace(/\/$/, '');
    
  const lobbyBasePath = normalizedLobbyUrl.split('/').slice(0, -1).join('/');

  const existWorldType = worldType ? (normalizedCurrentPath.endsWith(worldType.toLowerCase()) || normalizedCurrentPath.endsWith(worldType)) : false;
  
  return normalizedCurrentPath === normalizedLobbyUrl
    || (lobbyBasePath && normalizedCurrentPath.startsWith(lobbyBasePath + '/') && existWorldType);
};

const createSelfCareButton = (onClick, text, imgSrc, customArrowImg) => (
  <div onClick={onClick} className='item-purple self-care-item'>
    <span>{text}</span>
    <Image src={customArrowImg || imgSrc} alt='left arrow' />
  </div>
);

export function renderAuthButtons(Config, props, prepareSameWindowUrlWithNavigateTo, isUserConnected, setShowSelfCareArea, customArrowImg, selfcarePageState) {
  const {lobbyUrl, businessLobbyUrl, businessLandPageUrl, newLoginUrl} = Config;
  const {userDetails} = props.authentication.loginData;
  const {IsContactPerson, role} = userDetails;

  const worldType = selfcarePageState?.epiData?.worldType; 
  const isUserIsInPrivateLobby = isUserInLobby(lobbyUrl, window.location.pathname, worldType);
  console.log('[renderAuthButtons] lobbyUrl:', lobbyUrl, 'currentPath:', window.location.pathname, 'isUserIsInPrivateLobby:', isUserIsInPrivateLobby);
  const isUserIsInBusinessLobby = businessLobbyUrl.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '');
  const isUserIsInBusinessLandPage =
    businessLandPageUrl && businessLandPageUrl.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '');
  const isOnlyContactBusinessUser = isOnlyContactBusiness(role);
  const isBusinessNavigationMode = props.isBusinessNavigation || props.headerData.tabs[props.headerData.tabIndex]?.isBusinessTab?.value;

  const selfCareButton = createSelfCareButton(
    () => {
      setShowSelfCareArea(false);
      if (isUserConnected) {
        prepareSameWindowUrlWithNavigateTo(lobbyUrl, props.context);
      } else {
        prepareSameWindowUrlWithNavigateTo(newLoginUrl, props.context);
      }
    },
    'כניסה לאזור אישי',
    require('./images/left.svg'),
    customArrowImg,
  );

  const businessSelfCareButton = createSelfCareButton(
    () => {
      setShowSelfCareArea(false);
      if (isUserConnected) {
        prepareSameWindowUrlWithNavigateTo(businessLobbyUrl, props.context);
      } else {
        prepareSameWindowUrlWithNavigateTo(newLoginUrl, props.context);
      }
    },
    'כניסה לאזור אישי עסקי',
    require('./images/left.svg'),
    customArrowImg,
  );

  if (!isUserConnected) {
    return isUserIsInBusinessLandPage ? businessSelfCareButton : selfCareButton;
  }

  if (isUserIsInPrivateLobby && !IsContactPerson) {
    return null;
  }

  if (isUserIsInPrivateLobby && IsContactPerson) {
    return businessSelfCareButton;
  }

  if (!isUserIsInPrivateLobby && !IsContactPerson) {
    return selfCareButton;
  }

  if (isUserIsInBusinessLobby && IsContactPerson) {
    return selfCareButton;
  }

  if (!isUserIsInPrivateLobby && IsContactPerson) {
    return (
      <div>
        {selfCareButton}
        {businessSelfCareButton}
      </div>
    );
  }

  return null;
}
